<template>
  <v-container fluid>
    <v-layout>
      <v-flex xs12>
        <div v-if="isUserAdmin">
          <router-view></router-view>
        </div>
        <v-alert v-else type="warning" :value="true">
          Доступ в данный раздел доступен только для пользователей с правами администратора!
          <v-btn depressed :to="{name: 'home'}" >На главную</v-btn>
        </v-alert>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data: () => ({
    showNotification: false
  }),
  computed: {
    ...mapGetters([
      'isUserAdmin'
    ])
  }
}
</script>
